<template>
    <div>
        <div class="action-form-container">
            <v-menu
                bottom
                right
                :internal-activator="true"
                v-model="openMenu"
                content-class="no-contain overflow-visible"
                :close-on-content-click="false"
            >
                <template v-slot:activator="{ attrs, on }">
                    <button
                        class="search-rank-btn"
                        v-bind="attrs"
                        v-on="on"
                    >
                        Tìm kiếm
                        <v-icon>mdi-magnify</v-icon>
                    </button>
                </template>

                <v-card 
                    width="300px"
                    outlined 
                    class="ma-0"
                >
                    <v-row class="pa-2">
                        <v-col cols="12">
                            <span class="filter-rank-header">
                                Tìm kiếm
                            </span>
                        </v-col>
                        <v-col cols="12">
                            <v-autocomplete
                                v-model="ministryId"
                                :items="listMinistry"
                                item-text="name"
                                item-value="id"
                                label="Bộ phận"
                                hide-details
                                clearable
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-autocomplete
                                v-model="rankId"
                                :items="listRank"
                                item-text="name"
                                item-value="id"
                                label="Lộ trình làm việc"
                                hide-details
                                clearable
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-autocomplete
                                v-model="userId"
                                :items="listUser"
                                item-text="fullName"
                                item-value="id"
                                label="Tên nhân sự"
                                hide-details
                                clearable
                            />
                        </v-col>
                        <v-col cols="12" class="text-center">
                            <button
                                class="accept-btn"
                                @click="searchListRank()"
                            >
                                Tìm kiếm
                            </button>
                        </v-col>
                    </v-row>
                </v-card>
            </v-menu>
            <div>
                <button
                    v-if="checkAuthorization('setting-rank_update')"
                    class="search-rank-btn"
                    @click="showChangeModal"
                >
                    Chuyển lộ trình làm việc
                    <v-icon>mdi-cached</v-icon>
                </button>
            </div>
        </div>

        <rank-change-form 
            :changeModal="changeModal"
            :allowChangeRank="allowChangeRank"
        />
    </div>
</template>

<script>
import RankChangeForm from './RankChangeForm'
export default {
    components: {
        RankChangeForm
    },

    props: {
        listMinistry: {
            type: Array,
            default: () => {[]}
        },
        listRank: {
            type: Array,
            default: () => {[]}
        },
        listUser: {
            type: Array,
            default: () => {[]}
        },
        changeModal: {
            type: Boolean,
            default: false
        },
        allowChangeRank: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            openMenu: false,
            ministryId: '',
            rankId: '',
            userId: '',
            elementId: ''
        }
    },

    methods: {
        searchListRank() {
            this.openMenu = false
            let elementId = ''

            if (this.elementId) {
                let e = document.getElementById(this.elementId)

                if (e) {
                    e.style.backgroundColor = 'white'
                }
            }

            if (this.userId) {
                let index = this.listUser.findIndex(u => u.id == this.userId) 

                if (index > -1) {
                    if ((!this.rankId || this.rankId == this.listUser[index].rankId) 
                        && (!this.ministryId || this.ministryId == this.listUser[index].ministryId)) {
                        elementId = 'user-' + this.userId
                    }
                }
            } else if (this.rankId) {
                let index = this.listRank.findIndex(r => r.id == this.rankId) 

                if (index > -1) {
                    if (!this.ministryId || this.ministryId == this.listRank[index].ministryId) {
                        elementId = 'rank-' + this.rankId
                    }
                }
            } else if (this.ministryId) {
                let index = this.listRank.findIndex(r => r.ministryId == this.ministryId) 

                if (index > -1) {
                    elementId = 'rank-' + this.listRank[index].id
                }
            }

            if (elementId) {
                this.elementId = elementId
                let e = document.getElementById(elementId)

                if (e) {
                    e.scrollIntoView({
                        block: "start", 
                        inline: "nearest",
                        behavior: "smooth"
                    })
                    e.style.backgroundColor = '#e8f0fe'
                }
            } else {
                this.$swal({
                    title: 'Không tìm thấy kết quả'
                })
            }
        },

        showChangeModal() {
            Bus.$emit('open-change-rank-modal')
        }
    }
}
</script>

<style scoped>
.action-form-container {
    display: flex;
    justify-content: space-between;
    padding: 10px 0px;
}

.filter-rank-header {
    font-size: 16px;
    font-weight: bold;
}

.search-rank-btn {
    padding: 5px 8px;
    border: 1px solid black;
    font-size: 14px;
    font-weight: 400;
    border-radius: 8px;
}

.search-rank-btn i {
    color: black
}

.accept-btn {
    background-color: #7367F0;
    width: 100px;
    height: 40px;
    font-size: 14px;
    color: white;
    font-weight: 400;
    border-radius: 8px;
}
</style>
